const PayTime: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className ?? ''}>
      <g clipPath="url(#clip0_6688_38754)">
        <path
          d="M8 1.33337C4.324 1.33337 1.33333 4.32404 1.33333 8.00004C1.33333 11.676 4.324 14.6667 8 14.6667C8.69667 14.6667 9.368 14.5587 10 14.3594V12.9401C9.382 13.1915 8.70733 13.3334 8 13.3334C5.05933 13.3334 2.66667 10.9407 2.66667 8.00004C2.66667 5.05937 5.05933 2.66671 8 2.66671C10.2333 2.66671 12.1468 4.04804 12.9401 6.00004H14.3594C13.508 3.29804 10.9793 1.33337 8 1.33337ZM7.33333 4.00004V7.724L4.86198 10.1954L5.80469 11.1381L8.66667 8.27608V4.00004H7.33333ZM12.9362 7.33337V8.30863C12.6942 8.33797 11.3333 8.58191 11.3333 10.1446C11.3333 12.4246 13.9779 11.7482 13.9779 13.2696C13.9779 14.0309 13.4627 14.0495 13.3581 14.0495C13.2627 14.0495 12.6354 14.0977 12.6354 12.9323H11.2891C11.2891 14.9063 12.7845 15.0632 13.0065 15.0925V16H13.7201V15.0925C13.9607 15.0638 15.3242 14.8491 15.3242 13.2605C15.3242 11.0725 12.6673 11.4918 12.6667 10.1498C12.6667 9.38111 13.3018 9.35681 13.3971 9.35681C13.5718 9.35681 13.987 9.50478 13.987 10.4414H15.3333C15.3333 8.64878 13.8836 8.36886 13.6549 8.32686V7.33337H12.9362Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_6688_38754">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PayTime;
